import React from 'react';
import ReactDOM from 'react-dom';
class Loader extends React.Component {
  	
	render() {
		return(
		     <div className="main-item">
				  <div className="animated-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>
				
				  <div className="static-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>	
				  
				  <div className="animated-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>
				  
				 <div className="static-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>	
				  
				  <div className="animated-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>

					 <div className="static-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>	
				  
				  <div className="animated-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>

					 <div className="static-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>	
				  
				  <div className="animated-background">
					<div className="background-masker btn-divide-left"></div>
				  </div>
				  
			</div> 
		)
	}
}

export default Loader;
